import { PortfolioRateOverview } from '@mews-commander/data-access';
import { LocalizedText, lt, showSuccessAlert, useDialogAction } from '@mews/framework';
import { IconName, ActionToolbarButton } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { useDeleteRates } from '../../../queries';
import { DELETE_RATE_STARTING_POINT } from '../../../utilities/userFlowTestIds';
import { DeleteRatesDialog } from './DeleteRatesDialog';

interface Props {
    selectedRows: PortfolioRateOverview[];
    resetRowSelection: () => void;
}
export const BulkDelete = ({ selectedRows, resetRowSelection }: Props) => {
    const deleteRatesMutation = useDeleteRates();

    const deleteRates = async () => {
        await deleteRatesMutation.mutateAsync(
            {
                rateIds: selectedRows.map((rate) => rate.id),
            },
            {
                onSuccess: () => {
                    showSuccessAlert({
                        title: lt('RatesDeletedMessage', {
                            numberOfRates: selectedRows.length,
                            rateName: selectedRows[0].name,
                        }),
                    });
                    resetRowSelection();
                },
            }
        );
    };

    const deleteAction = useDialogAction(deleteRates);
    const areNoRowsSelected = selectedRows.length === 0;

    return (
        <>
            <ActionToolbarButton
                icon={IconName.Delete}
                disabled={areNoRowsSelected}
                onClick={deleteAction.handlers.handleOpen}
                data-test-id={DELETE_RATE_STARTING_POINT}
            >
                <LocalizedText textKey={TextKey.Delete} />
            </ActionToolbarButton>
            {deleteAction.states.isDialogOpened && (
                <DeleteRatesDialog rates={selectedRows} deleteAction={deleteAction} />
            )}
        </>
    );
};
